<template>
    <div class="batchBid">
        <el-dialog
            title="分批开标"
            :visible.sync="showBatchBidDialog"
            width="400px"
            :before-close="closeDialog">
            <span class="label">标段名称：</span>
            <el-input
                placeholder="请输入标段名称"
                v-model="extStr1">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="confirm" :loading="loadding">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { wonInTurn } from '../../../api/tenderDetails.js';
export default {
    name: 'batch-bid-dialog',
    data () {
        return {
            extStr1: '',
            loadding: false
        };
    },
    props: {
        showBatchBidDialog: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        formData: {
            type: Object,
            default: function() {
                return {};
            }
        },
        bidNo: {
            type: String,
            default: function() {
                return '';
            }
        },
    },
    components: {},
    methods: {
        closeDialog() {
            this.$emit('update:showBatchBidDialog', false);
        },
        // /** 分批开标提醒 **/
        // async confirmCheck () {
        //     this.loadding = true
        //     // const res = await beforeWonOpenCheck({ bidNo: this.bidNo, tenderCode: this.formData.tenderCode }).catch(err => { this.loadding = false })
        //     const res = await beforeWonOpenCheck({ tenderCode: this.formData.tenderCode, extStr1: this.extStr1 }).catch(err => { this.loadding = false })
        //     this.loadding = false
        //     if (!res || +res.code !== 0) {
        //         return Promise.reject()
        //     }
        //     if (res.data) {
        //         return this.$confirm(res.data, '分批开标提醒', {
        //             confirmButtonText: '确定',
        //             cancelButtonText: '取消'
        //         })
        //     } else {
        //         return Promise.resolve()
        //     }
        // },
        confirm() {
            if (this.extStr1) {
                this.$confirm('本轮参与报价的供应商有' + this.formData.currentSuppliers + '个，已提交报价供应商' + this.formData.supplierQuote + '个，是否要开标？', '分批开标确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    // this.confirmCheck().then(() => { this.confirmReq() })
                    this.confirmReq()
                }).catch(() => {});
            } else {
                this.$message.warning('请输入线路名称');
            }
        },
        confirmReq() {
            this.loadding = true;
            wonInTurn({ tenderCode: this.formData.tenderCode, extStr1: this.extStr1 }).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('分批开标成功');
                    this.$emit('getBidData');
                    this.closeDialog();
                } else {
                    this.extStr1s = this.extStr1s.join('，');
                }
            }).finally(() => { this.loadding = false; });
        }
    },
    mounted() {
    }
};
</script>
<style lang="less">
.batchBid {
    .label {
        font-size: 14px;
    }

    .el-input {
        width: 70%;
    }
}
</style>